module.exports = __webpack_public_path__ + "img/1078564120.e58437e1.jpg";